import * as assert from 'assert';
import { failure, PathReporter } from 'io-ts/PathReporter';
import { isRight, isLeft } from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
export function assertStrictEqual(result, expected) {
    if (isRight(result)) {
        assert.deepStrictEqual(result.right, expected);
    }
    else {
        throw new Error(failure(result.left).join('\n'));
    }
}
export function assertSuccess(result, expected) {
    if (isRight(result)) {
        if (expected !== undefined) {
            assert.deepStrictEqual(result.right, expected);
        }
    }
    else {
        throw new Error(failure(result.left).join('\n'));
    }
}
export function assertStrictSuccess(result, expected) {
    if (isRight(result)) {
        if (expected !== undefined) {
            assert.strictEqual(result.right, expected);
        }
    }
    else {
        throw new Error(failure(result.left).join('\n'));
    }
}
export function assertFailure(codec, value, errors) {
    var result = codec.decode(value);
    if (isLeft(result)) {
        assert.deepStrictEqual(PathReporter.report(result), errors);
    }
    else {
        throw new Error("".concat(String(result.right), " is not a left"));
    }
}
/**
 * Assert all Optional laws
 *
 * Laws:
 * 1. getOption(s).fold(() => s, a => set(a)(s)) = s
 * 2. getOption(set(a)(s)) = getOption(s).map(_ => a)
 * 3. set(a)(set(a)(s)) = set(a)(s)
 */
export function assertOptional(_a, s, a) {
    var getOption = _a.getOption, set = _a.set;
    assert.deepStrictEqual(pipe(getOption(s), O.fold(function () { return s; }, function (a) { return set(a)(s); })), s);
    assert.deepStrictEqual(getOption(set(a)(s)), pipe(getOption(s), O.map(function () { return a; })));
    assert.deepStrictEqual(set(a)(set(a)(s)), set(a)(s));
}
